import {IMAGE_BASE_URL} from '~/constants/image.constant'
import {META} from '~/environment-variables/meta.const'
import {ogTypeType, twitterCardType} from '~/types/meta.types'

export const getMeta = (title?: string, description?: string) => {
  const route = useRoute()
  return {
    title: title,
    description: description ? `${description} on ${META.siteName}` : META.description,
    ogTitle: '%s %separator %siteName',
    get ogDescription() {
      return this.description
    },
    ogType: 'website' as ogTypeType,
    ogUrl: import.meta.env.VITE_APP_BASE_URL + route.fullPath,
    ogSiteName: META.siteName,
    ogImage: `${IMAGE_BASE_URL}/og_image_mainnet.png`,
    ogImageWidth: 1200,
    ogImageHeight: 630,
    twitterCard: 'summary_large_image' as twitterCardType,
    twitterTitle: '%s %separator %siteName',
    get twitterDescription() {
      return this.description
    },
    get twitterImage() {
      return this.ogImage
    },
    keywords: META.keywords, // deprecated
  }
}
